import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M8 21h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 17v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17 8 5-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 3h5v5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ScreenShare";
const ScreenShare = memo(themed(Icon));
export {
  ScreenShare
};
//# sourceMappingURL=screen-share.js.map
